export enum ReportHyperKey {
  // OP (OI/OE/AI/AE/OT)
  DutyPendings = 'DutyPendings',
  NewProfitDetail1 = 'NewProfitDetail1',
  NewProfitDetail2GP = 'NewProfitDetail2GP',
  NewProfitDetail2 = 'NewProfitDetail2',
  EmpPerformanceDetail = 'EmpPerformanceDetail',

  // Accounting
  DeferredDetail = 'DeferredDetail',
  NewGLBalanceDetail = 'NewGLBalanceDetail',
  NewVendorCostDetail = 'NewVendorCostDetail',
  GLAgingByEntityDetail = 'GLAgingByEntityDetail',
  AccountDetail = 'AccountDetail',
  NewARAgingDetail = 'NewARAgingDetail',
  NewAPAgingDetail = 'NewAPAgingDetail',
  NewPayAgingDetail = 'NewPayAgingDetail',
  NewRecAgingDetail = 'NewRecAgingDetail',
  NewCheckPayableDetail = 'NewCheckPayableDetail',
  NewCheckReceivableDetail = 'NewCheckReceivableDetail',
  NewAgentARAgingDetail = 'NewAgentARAgingDetail',
  NewAgentAPAgingDetail = 'NewAgentAPAgingDetail',
  NewCCPayableDetail = 'NewCCPayableDetail',
  NewAgentAgingDetail = 'NewAgentAgingDetail',
  NewAgentAgingDetail2 = 'NewAgentAgingDetail2',
  GLDetailN = 'GLDetailN',
  BankDetailN = 'BankDetailN',
  ACTBalanceByEntity = 'ACTBalanceByEntity',
  JournalVoucher = 'JournalVoucher',
  JournalVoucherWithJournal = 'JournalVoucherWithJournal',
  PrevBankTranDetail = 'PrevBankTranDetail',
  TranSummDetail = 'TranSummDetail',
  PrevTranDetail = 'PrevTranDetail',
  FutrTranDetail = 'FutrTranDetail',
  GPDetailByCustomer = 'GPDetailByCustomer',
  SalesCostByCustomer = 'SalesCostByCustomer',
  CustomerGrossProfit = 'CustomerGrossProfit',
  CargoTypeYears = 'CargoTypeYears',
  TotalSalesClient = 'TotalSalesClient',
  DutyDetail = 'DutyDetail',
}

